// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__10mr4","dragIcon":"SortableItem_dragIcon__cVW8o","disabled":"SortableItem_disabled__RqQL9"};